import React, {useState} from "react";
import {
    Card,
    Layout, List,
    Page,
} from "@shopify/polaris";
import AppSubscribe from "../components/AppSubscribe";
import Br from "../components/Br";

const Pricing = () => {
    const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
    const [loadingSubscription, setLoadingSubscription] = useState(true);
    return (<Page fullWidth title="">
        <div className="smallPricingTable">
            <AppSubscribe setLoadingSubscription={setLoadingSubscription}
                          hasActiveSubscription={hasActiveSubscription} show={true}
                          setHasActiveSubscription={setHasActiveSubscription}/>
        </div>
        <Layout>
            <Layout.Section>
                <Br height={30}/>
                <Card title='Pricing details'>
                    <Card.Section>
                        <List type='bullet'>
                            <List.Item>Pricing works like how SMS cost works.</List.Item>
                            <List.Item>Price per message varies depending on the countries. Just like SMS
                                cost</List.Item>
                            <List.Item>Cost of messages will apply during the trial period</List.Item>
                            <List.Item>WhatsApp charges a fee per automated message</List.Item>
                            <List.Item><a
                                href="https://docs.google.com/spreadsheets/d/1S_HvAcQXzekTl9JfH18iRljZfCeJnNJbvQaOoB8-Fic/edit?usp=sharing"
                                target='_blank'>Check the country wide message cost</a></List.Item>
                            <List.Item>We automatically send your WhatsApp contact link, which customers can use to
                                message
                                back in case if they have a question</List.Item>
                        </List>
                    </Card.Section>
                </Card>
            </Layout.Section>
        </Layout>
    </Page>);
}

export default Pricing;
